/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';
import { DxiConstantLineComponent } from './constant-line-dxi';
import { DxiStripComponent } from './strip-dxi';



export class DxoValueAxisComponent extends NestedOption {
    
    get allowDecimals(): boolean {
        return this._getOption('allowDecimals');
    }
    set allowDecimals(value: boolean) {
        this._setOption('allowDecimals', value);
    }

    
    get axisDivisionFactor(): number {
        return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value: number) {
        this._setOption('axisDivisionFactor', value);
    }

    
    get categories(): Array<number|
        string|
        Date> {
        return this._getOption('categories');
    }
    set categories(value: Array<number|
        string|
        Date>) {
        this._setOption('categories', value);
    }

    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get constantLines(): Array<any|
        { color?: string, dashStyle?: string, label?: { font?: DevExpress.viz.Font, text?: string, visible?: boolean }, value?: Date|
        number|
        string, width?: number }> {
        return this._getOption('constantLines');
    }
    set constantLines(value: Array<any|
        { color?: string, dashStyle?: string, label?: { font?: DevExpress.viz.Font, text?: string, visible?: boolean }, value?: Date|
        number|
        string, width?: number }>) {
        this._setOption('constantLines', value);
    }

    
    get constantLineStyle(): any {
        return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value: any) {
        this._setOption('constantLineStyle', value);
    }

    
    get discreteAxisDivisionMode(): string {
        return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value: string) {
        this._setOption('discreteAxisDivisionMode', value);
    }

    
    get endOnTick(): boolean {
        return this._getOption('endOnTick');
    }
    set endOnTick(value: boolean) {
        this._setOption('endOnTick', value);
    }

    
    get grid(): any {
        return this._getOption('grid');
    }
    set grid(value: any) {
        this._setOption('grid', value);
    }

    
    get inverted(): boolean {
        return this._getOption('inverted');
    }
    set inverted(value: boolean) {
        this._setOption('inverted', value);
    }

    
    get label(): any {
        return this._getOption('label');
    }
    set label(value: any) {
        this._setOption('label', value);
    }

    
    get logarithmBase(): number {
        return this._getOption('logarithmBase');
    }
    set logarithmBase(value: number) {
        this._setOption('logarithmBase', value);
    }

    
    get maxValueMargin(): number {
        return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value: number) {
        this._setOption('maxValueMargin', value);
    }

    
    get minorGrid(): any {
        return this._getOption('minorGrid');
    }
    set minorGrid(value: any) {
        this._setOption('minorGrid', value);
    }

    
    get minorTick(): any {
        return this._getOption('minorTick');
    }
    set minorTick(value: any) {
        this._setOption('minorTick', value);
    }

    
    get minorTickCount(): number {
        return this._getOption('minorTickCount');
    }
    set minorTickCount(value: number) {
        this._setOption('minorTickCount', value);
    }

    
    get minorTickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('minorTickInterval', value);
    }

    
    get minValueMargin(): number {
        return this._getOption('minValueMargin');
    }
    set minValueMargin(value: number) {
        this._setOption('minValueMargin', value);
    }

    
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    
    get setTicksAtUnitBeginning(): boolean {
        return this._getOption('setTicksAtUnitBeginning');
    }
    set setTicksAtUnitBeginning(value: boolean) {
        this._setOption('setTicksAtUnitBeginning', value);
    }

    
    get showZero(): boolean {
        return this._getOption('showZero');
    }
    set showZero(value: boolean) {
        this._setOption('showZero', value);
    }

    
    get strips(): Array<any|
        { color?: string, endValue?: Date|
        number|
        string, label?: { font?: DevExpress.viz.Font, text?: string }, startValue?: Date|
        number|
        string }> {
        return this._getOption('strips');
    }
    set strips(value: Array<any|
        { color?: string, endValue?: Date|
        number|
        string, label?: { font?: DevExpress.viz.Font, text?: string }, startValue?: Date|
        number|
        string }>) {
        this._setOption('strips', value);
    }

    
    get stripStyle(): any {
        return this._getOption('stripStyle');
    }
    set stripStyle(value: any) {
        this._setOption('stripStyle', value);
    }

    
    get tick(): any {
        return this._getOption('tick');
    }
    set tick(value: any) {
        this._setOption('tick', value);
    }

    
    get tickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('tickInterval');
    }
    set tickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('tickInterval', value);
    }

    
    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }

    
    get valueMarginsEnabled(): boolean {
        return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value: boolean) {
        this._setOption('valueMarginsEnabled', value);
    }

    
    get valueType(): string {
        return this._getOption('valueType');
    }
    set valueType(value: string) {
        this._setOption('valueType', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    
    get width(): number {
        return this._getOption('width');
    }
    set width(value: number) {
        this._setOption('width', value);
    }

    
    get max(): number {
        return this._getOption('max');
    }
    set max(value: number) {
        this._setOption('max', value);
    }

    
    get min(): number {
        return this._getOption('min');
    }
    set min(value: number) {
        this._setOption('min', value);
    }

    protected get _optionPath() {
        return 'valueAxis';
    }


    
    get constantLinesChildren(): QueryList<DxiConstantLineComponent> {
        return this._getOption('constantLines');
    }
    set constantLinesChildren(value) {
        this.setChildren('constantLines', value);
    }

    
    get stripsChildren(): QueryList<DxiStripComponent> {
        return this._getOption('strips');
    }
    set stripsChildren(value) {
        this.setChildren('strips', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-value-axis',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowDecimals': [{ type: Input },],
'axisDivisionFactor': [{ type: Input },],
'categories': [{ type: Input },],
'color': [{ type: Input },],
'constantLines': [{ type: Input },],
'constantLineStyle': [{ type: Input },],
'discreteAxisDivisionMode': [{ type: Input },],
'endOnTick': [{ type: Input },],
'grid': [{ type: Input },],
'inverted': [{ type: Input },],
'label': [{ type: Input },],
'logarithmBase': [{ type: Input },],
'maxValueMargin': [{ type: Input },],
'minorGrid': [{ type: Input },],
'minorTick': [{ type: Input },],
'minorTickCount': [{ type: Input },],
'minorTickInterval': [{ type: Input },],
'minValueMargin': [{ type: Input },],
'opacity': [{ type: Input },],
'setTicksAtUnitBeginning': [{ type: Input },],
'showZero': [{ type: Input },],
'strips': [{ type: Input },],
'stripStyle': [{ type: Input },],
'tick': [{ type: Input },],
'tickInterval': [{ type: Input },],
'type': [{ type: Input },],
'valueMarginsEnabled': [{ type: Input },],
'valueType': [{ type: Input },],
'visible': [{ type: Input },],
'width': [{ type: Input },],
'max': [{ type: Input },],
'min': [{ type: Input },],
'constantLinesChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiConstantLineComponent), ] },],
'stripsChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiStripComponent), ] },],
};
}


export class DxoValueAxisModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoValueAxisComponent
  ],
  exports: [
    DxoValueAxisComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
